import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = [
        'slider',
        'autoplayProgress',
    ];

    static values = {
        config: { type: Object, default: {} },
    };

    initialize() {
        this._splide = null;
    }

    connect() {
        this.load();
    }

    disconnect() {
        if (this._splide) {
            this._splide.destroy();
            this._splide = null;
        }
    }

    async load() {
        const Swiper = (await import('swiper')).Swiper;
        const config = {
            ...this.configValue,
            modules: [],
            on: {},
        };

        if (config.autoplay) {
            const Autoplay = (await import('swiper/modules')).Autoplay;
            config.modules.push(Autoplay);

            if (this.hasAutoplayProgressTarget) {
                config.on.autoplayTimeLeft = (s, time, progress) => {
                    this.autoplayProgressTarget.firstElementChild.style.setProperty('--progress', `${100- (progress * 100)}%`);
                };
            }
        }

        this._splide = new Swiper(this.sliderTarget, config);
    }

    next() {
        this._splide.slideNext();
    }

    prev() {
        this._splide.slidePrev();
    }
}
